module.exports = __webpack_public_path__ + "pnskfsquadron/img/kr-slider-6.jpg?df04c64d";